import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  weekDaysContainer: {
    marginLeft: 20,
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)'
  },

  root: {
    display: 'flex',
    marginBottom: 60,
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  contractDetailsRoot: {
    flex: 1,
    paddingLeft: 16
  },
  datePickerContainer: {
    [theme.breakpoints.down('sm')]: {
      zIndex: 10000
    }
  },
  datePickerContainerForMobile: {
    marginTop: 20
  }
}))

export default useStyles
